// Reglas de las imagenes que se adjuntan a un comentario.
//
// Los limites por omision son los que fijo VIVA-353 para comentarios de evento
// —JPG/PNG/WebP, 5 MB por imagen y 30 imagenes por comentario—, pero aqui son
// PARAMETROS, no constantes cerradas: otra pantalla que monte la seccion puede
// apretarlos por la prop `adjuntos` sin tocar este archivo.
//
// Viven separados del componente porque son reglas de negocio y se pueden probar
// sin montar la interfaz.
//
// OJO al conectar un backend nuevo: estas validaciones solo corren en el
// navegador. Hay que confirmar que el endpoint aplique los mismos tres limites; si
// no coinciden, el usuario vera aceptada una imagen que el servidor rechaza.

export const COMMENT_IMAGE_MAX_COUNT = 30;
export const COMMENT_IMAGE_MAX_BYTES = 5 * 1024 * 1024;
export const COMMENT_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];

export const ERROR_FORMATO = "formato";
export const ERROR_TAMANO = "tamano";
export const ERROR_CANTIDAD = "cantidad";

// Filtra los archivos elegidos contra las tres reglas y devuelve tanto los que
// pasan como el motivo del primer rechazo, para que la pantalla pueda decir que
// fue lo que fallo en vez de descartar en silencio.
export const validarAdjuntosComentario = (
  archivos = [],
  yaAdjuntas = 0,
  {
    maxCantidad = COMMENT_IMAGE_MAX_COUNT,
    maxBytes = COMMENT_IMAGE_MAX_BYTES,
    tipos = COMMENT_IMAGE_TYPES,
  } = {}
) => {
  const aceptadas = [];
  let error = null;

  for (const archivo of archivos) {
    if (!tipos.includes(archivo?.type)) {
      error = error || ERROR_FORMATO;
      continue;
    }

    if (Number(archivo?.size ?? 0) > maxBytes) {
      error = error || ERROR_TAMANO;
      continue;
    }

    if (yaAdjuntas + aceptadas.length >= maxCantidad) {
      error = error || ERROR_CANTIDAD;
      break;
    }

    aceptadas.push(archivo);
  }

  return { aceptadas, error };
};
